module.exports = __webpack_public_path__ + "img/scanimation.d0045d49.gif";